import React from "react";
import { ILead } from "../../../redux/leads/leads.types";
import { BookingDetailsDisplay } from "../../dashboard/Dashboard/components/ViewLeadDeatils/BookingDetailsDisplay";
import { alpha, Box, Button, Grid, Stack, Typography } from "@mui/material";
import { RightPanel } from "../../../components/RightPanel";
import { Close } from "@mui/icons-material";
import { useTheme } from "@emotion/react";
import { InventoryBookingDetails } from "../componets/InventoryBookingDetails";


interface IViewOngoingLeadDialogProps {
    open: boolean;
    leads: ILead[];
    onClose: () => void;
}

export const ViewOngoingLeadDialog: React.FC<
    IViewOngoingLeadDialogProps
> = (props) => {
    const { open, leads, onClose } = props;
    const theme = useTheme();
    return (
        <RightPanel heading="View Booking Details"
            open={open}
            width="80%"
            onClose={onClose}
            actionButtons={() => (
                <Box display={"flex"} justifyContent={"space-between"} width="100%">
                    <Stack direction={"row"} spacing={2} justifyContent={"flex-start"}>
                        <Button variant="contained" onClick={onClose}>
                            <Close sx={{ fontSize: 18, mr: 0.5 }} />
                            Close
                        </Button>
                    </Stack>
                </Box>
            )}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: 'column',
                    columnGap: 2,
                }}
            >
                {leads.map((lead) => {
                    return (
                        <InventoryBookingDetails data={lead} />
                    )
                })}
            </Box>
        </RightPanel>
    );
};
